module.exports = __webpack_public_path__ + "img/sankaku_79_red.b14c7a3e.png";